import { render } from "./SvgIcon.vue?vue&type=template&id=1da46962"
import script from "./SvgIcon.vue?vue&type=script&lang=ts"
export * from "./SvgIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script